import { createSlice } from "@reduxjs/toolkit";
import { ParentGuardianResponseDto } from "../../shared/dtos/parentGuardian/ParentGuardianResponseDto";
import { ParentGuardianSummaryDto } from "../../shared/dtos/parentGuardian/ParentGuardianSummaryDto";
import {
  getInitialCrudState,
  generateCrudReducers,
} from "../utils/crudFactory";

export const parentSlice = createSlice({
  name: "parent",
  initialState: getInitialCrudState<
    ParentGuardianResponseDto,
    ParentGuardianSummaryDto
  >(),
  reducers: {
    ...generateCrudReducers<
      ParentGuardianResponseDto,
      ParentGuardianSummaryDto
    >(),
  },
});

export const parentActions = parentSlice.actions;
export default parentSlice.reducer;
